import flatten from 'flat';
import monitor from './fr-FR/monitor';

export default flatten({ ...monitor });
